import React from "react";
import { useSelector } from 'react-redux';

import RedirectRenderer from "src/components/redirect-renderer";

const redirects = [
  { from: '/organisations', to: '/admin/organisations' },
];

const Payments = () => {
  const { organisation: { organisations, is_admin } } = useSelector((state) => state);

  if (typeof organisations === 'object' && is_admin === true) {
    return (
      <React.Fragment>
        {RedirectRenderer({ redirects })}
      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Payments;
